export enum ADLNeedQuestionnaireItem {
  ADL_NEEDS = 'adl-needs',
  ADL_NEEDS_NEED = 'adl-needs/need',
  ADL_NEEDS_NEED_ID = 'adl-needs/need/id',
  ADL_NEEDS_NEED_OBSERVATION_REFERENCE = 'adl-needs/need/observation-reference',
  ADL_NEEDS_NEED_NAME = 'adl-needs/need/name',
  ADL_NEEDS_NEED_NEW_NOTE = 'adl-needs/need/new-note',
  ADL_NEEDS_NEED_IS_ARCHIVED = 'adl-needs/need/is-archived',
  ADL_NEEDS_NEED_LAST_NOTE_AUTHOR = 'adl-needs/need/last-note-author',
  ADL_NEEDS_NEED_LAST_NOTE_DATE = 'adl-needs/need/last-note-date',
  ADL_NEEDS_NEED_LAST_NOTE_TEXT = 'adl-needs/need/last-note-text'
}
